import { subscribeToThreads } from '@tiptap-pro/extension-comments';
import type { TCollabThread, TiptapCollabProvider } from '@tiptap-pro/provider';
import { Observable } from 'rxjs';

/**
 * RxJS wrapper around Tiptap's `subscribeToThreads`.
 * Emits whenever the thread list for the given provider changes.
 * Unsubscribes from Tiptap automatically when the Observable is torn down.
 */
export function observeThreads(provider: TiptapCollabProvider): Observable<TCollabThread[]> {
  return new Observable<TCollabThread[]>((subscriber) => {
    const unsubscribe = subscribeToThreads({
      provider,
      callback: (threads) => subscriber.next(threads),
    });
    return () => unsubscribe();
  });
}
